import { writeBatch } from 'firebase/firestore';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import React, { useCallback, useContext, useState } from 'react'
import { GolfTournamentContext } from '../cnr/contexts/GolfTournamentContext';
import { deleteFromObject, removeFromObject } from 'global/common/sorting';
import { golfTournamentHelpers } from '../cnr/reducers/reducerHelpers/golfTournamentHelpers';

export const _allowGolferUpdates = true

const removeFields_golferTournament = ['_itemKey', 'id', 'handicap', 'checked']

const deleteFields_golferTournament = [
  '_authData',
  '_authId',
  '_courseHandicaps',
  '_dateProps',
  '_existingKey',
  '_itemKey',
  '_recommendedCourseHandicap',
  '_recommendedTeeBox',
  '_updateDate',
  'auth_uid',
  'courseRoundHandicap',
  'firstName',
  'groupNumber',
  'handicapIndex',
  'handicapSourceType',
  'id',
  'key',
  'lastName',
  'name',
  'phoneNumber',
  'shortName',
  'teebox',
  'wtf',
]

export const useGolfers = () => {

  const parentContext = useContext(ParentContext)
  const { fns, states } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { mainDb } = app_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns

  const golfTournamentContext = useContext(GolfTournamentContext)
  const { golfTournament_state } = golfTournamentContext ? golfTournamentContext : {}
  const { golfTournament: gt, teams, golfCourse, rounds, golfers: golfers_tournament } = golfTournament_state ?? {}
  const { holes } = golfCourse ?? {}
  const { id: gtid } = gt ?? {}

  const [updating, setUpdating] = useState()

  const get_golferRecords = useCallback(({ matches, golfers, teams }) => {
    const { golferRecords, golferRecordsSorted } = golfTournamentHelpers.getGolferResults(
      {
        matches,
        golfers,
        golfCourse,
        teams
      })
    return { golferRecords, golferRecordsSorted }
  }, [golfCourse])


  const get_courseRoundHandicaps = useCallback(({ golfers, selectedRoundType }) => {
    const round = rounds?.[selectedRoundType]
    const { golfCourse } = round ?? {}
    _.forEach(golfers, (golfer, itemKey) => {
      if (!golfer.courseRoundHandicap) {
        golfer.courseRoundHandicap = golfer?.courseHandicaps?.[golfCourse]
      }
    })
  }, [])

  const get_golferHandicaps = useCallback(({ golfer }) => {

    const {
      key: key_golfer,
      _authData,
      teamNumber,
      lastName,
      firstName,
      courseHandicaps,
      allowLineupModification,
      handicapSourceType,
      courseTeeboxes,
      tournamentHandicapIndex,
      _recommendedCourseHandicap,
      _recommendedTeeBox,
      handicapIndex,
      matchHandicap_alt_perc,
      matchHandicap_alt,
      _dateProps
    } = golfer

    const { daysSinceUpdate } = _dateProps ? _dateProps : {}
    const _handicaps = {
      golfer: tournamentHandicapIndex,
      handicapIndex: handicapIndex,
      tournamentHandicapIndex: tournamentHandicapIndex,
      handicapSource: handicapSourceType ? handicapSourceType.substring(0, 4).toUpperCase() : '?',
      courseHandicap: courseHandicaps ? Object.values(courseHandicaps)[0] : null,
      recommendedCourseHandicap: _recommendedCourseHandicap || null,
      recommendedTeeBox: _recommendedTeeBox || null,
      teebox: courseTeeboxes ? Object.values(courseTeeboxes)[0] : null,
      matchHandicap_alt_perc,
      matchHandicap_alt,
      missing: '?',
      hasHandicap: false,
      hasCourseHandicap: false,
      daysSinceUpdate: daysSinceUpdate,
    }
    _handicaps.hasHandicap = _handicaps.golfer ? true : false
    _handicaps.hasCourseHandicap = _handicaps.courseHandicap ? true : false
    return _handicaps
  }, [])

  const create_golfer = useCallback(async ({ golfer }) => {
    setUpdating(true);
    try {
      const refPath = createRefPath_event(pathViews, ['golfers'])
      const batch = writeBatch(mainDb);
      database_fns.add_doc(refPath, golfer, null, batch);
      if (_allowGolfUpdates) {
        await batch.commit()
      }
      setUpdating(false)
    } catch (error) {
      console.error("Error saving handicaps:", error);
      setUpdating(false)
    } finally {
      setUpdating(false);
    }
  }, [])

  const update_eventGolfer = useCallback(async ({ golfer }) => {
    setUpdating(true);
    try {
      const batch = writeBatch(mainDb);
      const _golfer = { ...golfer }
      const { _itemKey } = _golfer
      removeFromObject(_golfer, ['_itemKey', 'id', 'handicap', 'checked'])
      const _updateRef = createRefPath_event(pathViews, ['golfers', _itemKey])
      //refPath, data, callback, batch
      database_fns.update_doc(_updateRef, _golfer, null, batch)
      console.log('_updateRef', _updateRef, _golfer)
      if (_allowGolferUpdates) {
        await batch.commit()
      }
    } catch (error) {
      console.error("Error saving handicaps:", error);
    } finally {
      setUpdating(false);
    }
  }, [])

  const update_tournamentGolfer = useCallback(async ({ golfTournament, golfer, callback }) => {
    setUpdating(true);
    try {
      const { _itemKey } = golfer
      if (_itemKey) {
        removeFromObject(golfer, removeFields_golferTournament)
        deleteFromObject(golfer, deleteFields_golferTournament)
        const dtu = {
          golfers: {
            [_itemKey]: golfer
          }
        }
        if (_allowGolferUpdates) {
          golfTournamentHelpers.updateGolfTournamentDetails(
            database_fns,
            gtid,
            pathViews,
            { ...dtu },
            callback)
        }
      }
      setUpdating(false);
    } catch (error) {
      console.error("Error saving handicaps:", error);
    } finally {
      setUpdating(false);
    }
  }, [])

  const handleUpdate_tournamentGolfersHandicaps = useCallback(async ({
    golfers,
    callback
  }) => {

    setUpdating(true);

    try {

      const _golfers = _.cloneDeep(golfers);

      Object.keys(_golfers).forEach(k => {

        const g = _golfers[k];

        removeFromObject(g, removeFields_golferTournament);
        deleteFromObject(g, deleteFields_golferTournament);

      });

      const dtua = {
        golfers: _golfers
      };

      console.log('dtua', dtua)

      const result = await golfTournamentHelpers.updateGolfTournamentDetails(
        database_fns,
        gtid,
        pathViews,
        dtua,
        callback
      );

      setUpdating(false);
      return result;

    } catch (error) {
      console.error(error);
      setUpdating(false);
    } finally {
      setUpdating(false);
    }
  }, [
    database_fns,
    gtid,
    pathViews,
    removeFields_golferTournament,
    deleteFields_golferTournament
  ]);

  const update_handicaps = useCallback(async ({ golfers }) => {
    setUpdating(true);
    const adds = []
    try {
      const refPath = createRefPath_event(pathViews, ['golfers']);
      const batch = writeBatch(mainDb);
      _.map(golfers, (golfer) => {
        adds.push(golfer)
        return database_fns.add_doc(refPath, golfer, null, batch);
      })
      if (_allowGolfUpdates) {
        await batch.commit()
      }
      handleCancel(false); // only after all docs saved
    } catch (error) {
      console.error("Error saving handicaps:", error);
    } finally {
      setUpdating(false);
    }
  }, [])

  const update_missingGolfers = useCallback(async ({ missingGolfers }) => {
    setUpdating(true);
    try {
      const deletes = []
      const batch = writeBatch(mainDb);
      _.map(missingGolfers, (golfer, gk) => {
        const refPath = createRefPath_event(pathViews, ['golfers', gk]);
        deletes.push({ gk, refPath, golfer })
        return database_fns.delete_doc(refPath, golfer, null, batch);
      })
      if (_allowGolfUpdates) {
        await batch.commit()
      }
      setUpdating(false);
    } catch (error) {
      console.error("Error adding golfers:", error);
      setUpdating(false);
    } finally {
      setUpdating(false);
    }
  }, [])

  const update_golfHandicapRecommendations = useCallback(({ golfers, golfCourse }) => {
    setUpdating(true);
    try {
      return recommendTeeBoxes({ golfers, golfCourse })
    } catch (error) {
      console.error("Error saving handicaps:", error);
      setUpdating(false);
    } finally {
      setUpdating(false);
    }
  }, [])

  const handleChange_golferTournament = useCallback(async ({
    existingGolferKey,
    newGolfer,
    _details,
    callback
  }) => {

    setUpdating(true);

    try {

      const { lineups: lineups_changed, golfers: golfer_changed } = golfTournamentHelpers.changeTournanemtGolfer({ existingGolferKey, newGolfer, _details });

      const result = await golfTournamentHelpers.updateGolfTournamentDetails(
        database_fns,
        gtid,
        pathViews,
        {
          golfers: golfer_changed,
          lineups: lineups_changed
        },
        callback
      );

      return result;

    } catch (error) {

      console.error(error);
      throw error;

    } finally {

      setUpdating(false);

    }

  }, []);


  return {
    updating,
    create_golfer,
    get_courseRoundHandicaps,
    get_golferHandicaps,
    get_golferRecords,
    handleChange_golferTournament,
    handleUpdate_tournamentGolfersHandicaps,
    update_eventGolfer,
    update_golfHandicapRecommendations,
    update_handicaps,
    update_missingGolfers,
    update_tournamentGolfer,
  }
}

function recommendTeeBoxes({ golfers, golfCourse, par = 72 }) {

  if (!golfCourse?.holes) return;

  const teeResults = Object.entries(golfCourse.teeBoxes)
    // .filter(([teeBoxKey]) => !teeBoxKey.includes('/'))
    .map(([teeBoxKey, teeBox]) => {

      const totalYardage = Object.values(golfCourse.holes)
        .reduce((total, hole) => total + (hole[teeBoxKey] || 0), 0)

      return {
        teeBoxKey,
        ...teeBox,
        totalYardage
      }
    })

  _.forEach(golfers, golfer => {

    const handicapIndex = golfer.tournamentHandicapIndex

    const options = teeResults.map(tee => {
      const courseHandicap = handicapIndex * (tee.slope / 113) + (tee.rating - par)
      return { ...tee, courseHandicap: Math.round(courseHandicap) }
    })

    const recommended =
      _.minBy(
        options.filter(tee => tee.courseHandicap >= handicapIndex),
        tee => tee.courseHandicap
      ) ||
      _.maxBy(options, tee => tee.courseHandicap)

    golfer._recommendedTeeBox = recommended.teeBoxKey
    golfer._recommendedCourseHandicap = recommended.courseHandicap
    golfer._courseHandicaps = options
  })
} 